<script setup>
  import { ref } from 'vue'
  import { getStorage, ref as storageRef, getDownloadURL } from 'firebase/storage'
  import { getApp } from 'firebase/app'
  import { RequestService } from '../services/RequestService'
  import BcsDynamicText from './BcsDynamicText.vue'

  defineProps({
    title: {
      type: String,
      required: true
    },
    dynamicTextKey: {
      type: String,
      default: ''
    },
    staticText: {
      type: String,
      default: ''
    },
    buttonLabel: {
      type: String,
      required: true
    },
    showSampleReportLink: {
      type: Boolean,
      default: false
    },
    sampleReportPath: {
      type: String,
      default: ''
    }
  })

  const emit = defineEmits(['navigate'])

  const { handleErrors } = RequestService()

  const downloading = ref(false)

  async function downloadSampleReport(path) {
    if (!path) return
    downloading.value = true
    try {
      const storage = getStorage(getApp())
      const fileRef = storageRef(storage, path)
      const url = await getDownloadURL(fileRef)
      const response = await fetch(url)
      const blob = await response.blob()
      const objectUrl = URL.createObjectURL(blob)
      const anchor = document.createElement('a')
      anchor.href = objectUrl
      anchor.download = path.split('/').pop()
      anchor.click()
      URL.revokeObjectURL(objectUrl)
    } catch (error) {
      handleErrors('Error downloading sample report:', error)
    } finally {
      downloading.value = false
    }
  }
</script>

<template>
  <div class="col-10 overlay-white-left">
    <div class="card mt-5 d-flex mx-auto">
      <div class="card-body text-center pt-5">
        <h5 class="card-title header-22">
          <i class="bi bi-exclamation-circle-fill text-danger"></i>
          &nbsp;
          <strong>{{ title }}</strong>
        </h5>
        <div class="card-text text-14 text-gray-700 mb-3">
          <BcsDynamicText v-if="dynamicTextKey" :text="dynamicTextKey" />
          <p v-else>{{ staticText }}</p>
        </div>
        <button
          class="btn btn-primary"
          @click="emit('navigate')"
        >
          <i class="bi bi-pencil"></i>
          &nbsp; {{ buttonLabel }}
        </button>
        <div v-if="showSampleReportLink" class="mt-3">
          <button
            class="btn btn-link text-primary text-decoration-underline p-0"
            :disabled="downloading || !sampleReportPath"
            @click="downloadSampleReport(sampleReportPath)"
          >
            <span v-if="downloading" class="spinner-border spinner-border-sm me-1" role="status"></span>
            View Sample Report
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.overlay-white-left {
  z-index: 99999;
}
</style>
